import "./src/css/tailwind.css"